// src/pages/PrivacyPolicy.tsx: public privacy policy at /privacy (no auth).
import React from 'react';
import LegalPage, { H2, P, List, Mail } from '../components/LegalPage';

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" updated="30 August 2026">
      <H2>1. Introduction</H2>
      <P>
        Altveno Ltd ("Altveno", "we", "us", "our") operates the Altveno alternative
        investment platform available at app.altveno.com and altveno.com (the
        "Platform"). We are committed to protecting the personal data of all users
        of our Platform.
      </P>
      <P>
        This Privacy Policy explains how we collect, use, store and share your
        personal data when you use our Platform or submit an application to join.
      </P>
      <P>If you have any questions, contact us at: <Mail /></P>

      <H2>2. Who We Are</H2>
      <P>Altveno Ltd is the data controller responsible for your personal data.</P>
      <P>Email: <Mail /></P>

      <H2>3. What Data We Collect</H2>

      <H2>3.1 Data you provide directly</H2>
      <P>When you apply for or use the Platform, we may collect:</P>
      <List items={[
        'Identity data: full name, job title, position',
        'Contact data: email address, phone number',
        'Professional data: firm name, regulatory number, jurisdiction, AUM, fund strategy, years of experience',
        'Financial data: subscription and invoice information',
        'Document data: CVs, due diligence questionnaires, fund documents',
        'Communications: messages sent via the Platform',
      ]} />

      <H2>3.2 Data collected automatically</H2>
      <List items={[
        'Usage data: pages visited, features used, time and frequency of use',
        'Technical data: IP address, browser type, device type',
        'Log data: access logs, error logs',
      ]} />

      <H2>3.3 Data from third parties</H2>
      <List items={[
        'Regulatory data: we may verify your regulatory status with the FCA, SEC, MAS, DIFC, ADGM or equivalent regulatory registers',
      ]} />

      <H2>4. How We Use Your Data</H2>
      <List items={[
        'To provide and operate the Platform (contract performance)',
        'To verify your regulatory status and identity (legal obligation)',
        'To process your application for platform access (contract performance)',
        'To send you service communications (contract performance)',
        'To send you platform notifications (contract performance)',
        'To improve and develop the Platform (legitimate interests)',
        'To detect and prevent fraud (legal obligation)',
        'To comply with legal and regulatory obligations (legal obligation)',
      ]} />

      <H2>5. Anonymous and Aggregated Data</H2>
      <P>
        The Platform uses anonymised and aggregated data to power our AI tools
        including market intelligence benchmarking and fund discovery. This data is
        fully anonymised, individual managers and funds cannot be identified from it.
      </P>

      <H2>6. Who We Share Your Data With</H2>
      <List items={[
        'Other Platform users: your profile is visible as you configure it',
        'Supabase (database, EU/US)',
        'Amazon Web Services (file storage, EU)',
        'Resend (transactional email)',
        'Anthropic (AI processing, no personal data stored)',
        'Vercel (web hosting)',
        'Regulatory bodies where required by law',
      ]} />
      <P>We do not sell your personal data to any third party.</P>

      <H2>7. Data Retention</H2>
      <List items={[
        'Active account data: duration of subscription plus 7 years',
        'Unsuccessful applications: 2 years',
        'Communications: 3 years',
        'Financial records: 7 years (legal requirement)',
        'Usage logs: 12 months',
      ]} />

      <H2>8. Your Rights</H2>
      <P>
        Under UK GDPR you have the right to: access, rectify, erase, restrict, port
        and object to processing of your data. Contact <Mail /> to exercise these
        rights.
      </P>
      <P>
        You may also complain to the ICO at{' '}
        <a href="https://ico.org.uk" target="_blank" rel="noreferrer"
           style={{ color: '#C9A84C', textDecoration: 'none' }}>ico.org.uk</a>.
      </P>

      <H2>9. Security</H2>
      <P>
        We implement encryption in transit and at rest, row-level security on all
        database tables, access controls and regular security reviews.
      </P>

      <H2>10. Changes to This Policy</H2>
      <P>
        We will notify you of significant changes by email. The date at the top
        indicates when this policy was last updated.
      </P>

      <H2>11. Contact Us</H2>
      <P>Email: <Mail /></P>
    </LegalPage>
  );
}
